import { useAtom } from "jotai";
import BookviewPanelStatusAtom from "utilities/atoms/bookview/bookview-panel-atom";
import { BookviewPanelStatus } from "models/enumerations/bookview-panel-status";
import useMetaNav from "utilities/atoms/metanav-visible-atom";
import useBreakpointRanges from "utilities/hooks/use-breakpoint-ranges";

export function useBookviewTabPanel() {
    const [bookviewPanelStatus, setBookviewPanelStatus] = useAtom(
        BookviewPanelStatusAtom
    );

    const { isMetaNavCollapsed, collapseMetaNav } = useMetaNav();
    const { isUnableToSupportAllBookviewPanels } = useBreakpointRanges();

    const isOpen = bookviewPanelStatus !== BookviewPanelStatus.None;

    const isRefPanelOpen =
        bookviewPanelStatus === BookviewPanelStatus.ReferencePanel;
    const isBookviewUserPreferencesOpen =
        bookviewPanelStatus === BookviewPanelStatus.UserSettingsPanel;
    const isShareSpacePanelOpen =
        bookviewPanelStatus === BookviewPanelStatus.ShareSpacePanel;
    const isBookviewChatPanelOpen =
        bookviewPanelStatus === BookviewPanelStatus.BookviewChatPanel;
    const isBookviewSearchPanelOpen =
        bookviewPanelStatus === BookviewPanelStatus.BookviewSearchPanel;

    const adjustMetaNavIfNeeded = () => {
        if (!isMetaNavCollapsed && isUnableToSupportAllBookviewPanels) {
            collapseMetaNav();
        }
    };

    const handleOpen = (panelToOpen: BookviewPanelStatus) => {
        adjustMetaNavIfNeeded();
        setBookviewPanelStatus(panelToOpen);
    };

    const handleClose = () => {
        setBookviewPanelStatus(BookviewPanelStatus.None);
    };

    const togglePanel = (panelStatus: BookviewPanelStatus) => {
        adjustMetaNavIfNeeded();
        bookviewPanelStatus === panelStatus
            ? setBookviewPanelStatus(BookviewPanelStatus.None)
            : setBookviewPanelStatus(panelStatus);
    };

    const toggleReferencePanel = () => {
        togglePanel(BookviewPanelStatus.ReferencePanel);
    };

    const toggleBookViewUserPreferences = () => {
        togglePanel(BookviewPanelStatus.UserSettingsPanel);
    };

    const toggleShareSpacePanel = () => {
        togglePanel(BookviewPanelStatus.ShareSpacePanel);
    };

    const toggleBookviewChatPanel = () => {
        togglePanel(BookviewPanelStatus.BookviewChatPanel);
    };

    const toggleBookviewSearchPanel = () => {
        // todo: change this when the search bar is functioning as expected
        // togglePanel(BookviewPanelStatus.BookviewSearchPanel);
        setBookviewPanelStatus(BookviewPanelStatus.BookviewSearchPanel);
    };

    return {
        handleOpen,
        handleClose,
        toggleReferencePanel,
        toggleBookViewUserPreferences,
        toggleShareSpacePanel,
        toggleBookviewChatPanel,
        toggleBookviewSearchPanel,
        isOpen,
        isRefPanelOpen,
        isBookviewUserPreferencesOpen,
        isShareSpacePanelOpen,
        isBookviewChatPanelOpen,
        isBookviewSearchPanelOpen,
    };
}
